// import Mock from 'mockjs'  //根本没有这个目录
// import Mock from '@sk/sk-ui-sdk/node_modules/mockjs'  //和手动npm i mockjs一样的效果，会导致不发请求且控制台报错
import Mock from 'mockjs-async' //可以


Mock.setup({
  timeout: '350-600'
})

import loginAPI from './login'
import userApi from './user'
import articleManageApi from './articleManage'
import settingApi from './setting'
import dataAnalysisApi from './dataAnalysis'
import fileManageApi from './fileManage'
import whitelistApi from './whitelist'
import activeOrganizationApi from './activeOrganization'
import characteristicOrgApi from './characteristicOrg'
console.log('mock', Mock)

// // 登录相关
Mock.mock(/\/lcp\/operations\/auth/, 'post', loginAPI.loginByPassword)
Mock.mock(/\/lcp\/user\/getUserInfo/, 'post', userApi.getUserMessage)
Mock.mock(/\/user\/smslogin/, 'post', loginAPI.loginByUserCode)
Mock.mock(/\/auth\/user\/logout/, 'post', loginAPI.logout)
Mock.mock(/\/rcdc\/base\/admin\/logoutAdmin/, 'post', loginAPI.logout)
Mock.mock(/\/auth\/rco\/admin\/validateAdminPwd/, 'post', loginAPI.validateAdminPwd)
Mock.mock(/\/user\/getUserInfo/, 'get', loginAPI.getUserInfo)
Mock.mock(/\/lcp\/user\/customerManagement\/getMaintainStatus/, 'post', userApi.getMaintenanceState)
Mock.mock(/\/rcdc\/noAuth\/login\/getNotice/, 'get', loginAPI.getNotice)






// 用户相关
Mock.mock(/\/user\/account\/detail/, 'get', userApi.getUserMessage)
Mock.mock(/\/user\/register/, 'post', userApi.register)
Mock.mock(/\/user\/resetPassword\/checkVerifyCode/, 'post', userApi.verifyCode)
Mock.mock(/\/user\/account\/phone\/edit/, 'post', userApi.editPhone)
Mock.mock(/\/user\/modifyUserPassword/, 'post', userApi.editPassword)
Mock.mock(/\/auth\/user\/getSmsVerifyCode/, 'post', userApi.sendVerifyCode)
Mock.mock(/\/user\/resetPassword\/reset/, 'post', userApi.resetPassword)
Mock.mock(/\/user\/addUserInfo/, 'post', userApi.editUserInfo)
Mock.mock(/\/user\/getAreaInfo/, 'post', userApi.getAreaInfo)
Mock.mock(/\/org\/checkOrgName/, 'post', userApi.checkOrgName)
Mock.mock(/\/user\/getOrgInfo/, 'post', userApi.getOrgInfoById)
Mock.mock(/\/user\/member\/org\/leave/, 'post', userApi.outOrg)
Mock.mock(/\/org\/checkDelete/, 'post', userApi.checkOrgDelete)
Mock.mock(/\/org\/delete/, 'post', userApi.deleteOrg)

// 文章管理
Mock.mock(/\/lcp\/operations\/category\/list/, 'post', articleManageApi.getCategoryList)
Mock.mock(/\/lcp\/operations\/article\/category\/add/, 'post', articleManageApi.handleSuccess)
Mock.mock(/\/lcp\/operations\/article\/category\/update/, 'post', articleManageApi.handleSuccess)
Mock.mock(/\/lcp\/operations\/article\/category\/delete/, 'post', articleManageApi.handleSuccess)
Mock.mock(/\/lcp\/operations\/article\/list/, 'post', articleManageApi.getArticleList)
Mock.mock(/\/lcp\/operations\/article\/detail/, 'post', articleManageApi.getArticleDetail)

// 文件管理
Mock.mock(/\/lcp\/operations\/file\/list/, 'post', fileManageApi.getFileList)

// 基本设置
Mock.mock(/\/lcp\/operations\/setting\/getHomePageSetting/, 'post', settingApi.getHomePageSetting)
Mock.mock(/\/lcp\/operations\/setting\/getInsidePageSetting/, 'post', settingApi.getInsidePageSetting)


// 数据分析
Mock.mock(/\/lcp\/operations\/analysis\/click/, 'post', dataAnalysisApi.getDataAnalysisList)

// 功能分析
// 白名单
// Mock.mock(/\/operationslcp\/operations\/whitelist\/getWhitelistInfo/, 'post', whitelistApi.getWhitelistInfo)
// Mock.mock(/\/operationslcp\/operations\/whitelist\/getWhitelist/, 'post', whitelistApi.getWhitelist)
// Mock.mock(/\/operationslcp\/operations\/whitelist\/getBehaviorList/, 'post', whitelistApi.getBehaviorList)
// Mock.mock(/\/operationslcp\/operations\/whitelist\/getOrgInfo/, 'post', whitelistApi.getOrgInfo)

// 组织活跃情况
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getCustomerBaseInfo/, 'post', activeOrganizationApi.getActiveOrganizationList)
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getTerminalDeployInfo/, 'post', activeOrganizationApi.getTerminalDeployInfo)
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getRepurchaseInfo/, 'post', activeOrganizationApi.getRepurchaseInfo)
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getWebBehaviorInfo/, 'post', activeOrganizationApi.getWebBehaviorInfo)
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getBehaviorDetail/, 'post', activeOrganizationApi.getBehaviorDetail)
// Mock.mock(/\/operationslcp\/operations\/customerinfo\/getFirstLoginBehavior/, 'post', activeOrganizationApi.getFirstLoginBehavior)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getTradeInfo/, 'post', activeOrganizationApi.getTradeInfo)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getAgencyOrg/, 'post', activeOrganizationApi.getAgencyOrg)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getTerminalIpStatisticInfo/, 'post', activeOrganizationApi.getTerminalIpStatisticInfo)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getCustomerTerminalBehavior/, 'post', activeOrganizationApi.getCustomerTerminalBehavior)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getshineBehaviorStatistic/, 'post', activeOrganizationApi.getTerminalBehaviorRank)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getOrderInfo/, 'post', activeOrganizationApi.getOrderInfo)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getTerminalList/, 'post', activeOrganizationApi.getTerminalList)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getTerminalGroup/, 'post', activeOrganizationApi.getTerminalGroup)

// 寻找特征组织
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getFeatureOrgRatio/, 'post', characteristicOrgApi.getDecentralizedOrg)
// Mock.mock(/\/operationslcp\/operations\/customerInfo\/getFeatureOrgInfo/, 'post', characteristicOrgApi.getDecentralizedOrgList)
export default Mock
